module.exports = __webpack_public_path__ + "static/img/2_2.4b0a4909.jpg";